import { createContext, useContext } from 'react';

export interface ICurrentUser {
  id: string;
  username: string;
  displayName: string;
  isOwner: boolean;
  permissions: string[];
  avatar: string | null;
}

export interface IAuthContext {
  currentUser: ICurrentUser | null;
}

const AuthContext = createContext<IAuthContext>({ currentUser: null });

interface IAuthProviderProps {
  currentUser: ICurrentUser | null;
  children: React.ReactNode;
}

export const AuthProvider = ({ currentUser, children }: IAuthProviderProps) => (
  <AuthContext.Provider value={{ currentUser }}>
    {children}
  </AuthContext.Provider>
);

export const useAuth = (): IAuthContext => useContext(AuthContext);
